import { Messages } from 'lib/intl/messages';

export const messages: Messages = {
  RELEASE_NOTES_INFO_MESSAGE: {
    en: 'RIPEye just got updated. Here are the updated notes.',
    de: 'RIPEye wurde gerade aktualisiert. Hier sind die aktualisierten Versionshinweise.',
  },
};
